@if ($orderEntry() && !$product().variantOptions) {
  <span>
    {{ 'message.productInCart' | transloco }}
  </span>
}
